import { Card } from '@reveni-io/reveni-ui'

import { hasRecommendation, hasRecommendationGlobal } from '@/metrics/helpers/helpers'

import SizingIssuesAlert from '../SizingIssuesAlert/SizingIssuesAlert'
import SizingIssuesCountries from '../SizingIssuesCountries/SizingIssuesCountries'
import SizingIssuesRegions from '../SizingIssuesRegions/SizingIssuesRegions'
import SizingIssuesTitle from '../SizingIssuesTitle/SizingIssuesTitle'
import * as Styles from './styles'

const SizingIssuesCard = ({ product }) => {
  const showRegions = hasRecommendationGlobal(product?.recommendation_global)
  const showCountries = hasRecommendation(product?.recommendation)
  const showBothColumns = showRegions && showCountries

  if (!product?.has_size_recommendation) {
    return null
  }

  return (
    <Card showBorder={false}>
      <SizingIssuesTitle />
      <Styles.ColumnsContainer templateColumns={showBothColumns ? '1fr 1fr' : '1fr'}>
        {showRegions && <SizingIssuesRegions recommendationGlobal={product?.recommendation_global} />}
        {showCountries && <SizingIssuesCountries recommendation={product?.recommendation} />}
      </Styles.ColumnsContainer>
      <Styles.BottomAlert>
        <SizingIssuesAlert size="medium" />
      </Styles.BottomAlert>
    </Card>
  )
}

export default SizingIssuesCard
